<template>
  <div class="main-nav">
    <v-toolbar  class="white primary--text" fixed>
      <v-toolbar-title>
        <router-link to="/LandingPage" tag="span" style="cursor: pointer" class="logo">ISSY</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <nav-items v-if="authorized"></nav-items>
      <v-btn  v-if="!user || !user.displayName" @click="signin" to="/LandingPage" class="hidden-xs-only primary darken-2">
        Sign in
      </v-btn>
    </v-toolbar>
    <nav-drawer></nav-drawer>
  </div>
</template>

<script>
import { signin } from "@/vue-service-auth.js";
import NavItems from "./NavItems";
import NavDrawer from "./NavDrawer";

export default {
  components: {
    "nav-items": NavItems,
    "nav-drawer": NavDrawer
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    authorized() {
      return this.$store.getters.authorized;
    },
  },
  methods: {
    signin
  },
};
</script>

<style scoped>
/* style the userImage to fit in nav */
.toolbar-title-img {
  max-width: 35px;
}
.beta-text {
  /* font-size: .75em; */
  color: lightcoral;
}
.logo{
  font-weight: bold;
  font-size: 30px;
}
.main-nav{
  z-index: 10;
  position: fixed;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue